{
	"hooks": {
		"exportSalesByEmployee": {
			"employee": "Employee",
			"filename": "single-sales-per-employee-",
			"filenameEvent": "at-event-{{eventName}}",
			"filenamePeriod": "-from-{{since}}-to-{{until}}",
			"title": "Single Sales by Employee ",
			"titleEvent": "at event {{eventName}} ",
			"titlePeriod": "from {{since}} to {{until}}"
		},
		"exportAllSalesFromEmployee": {
			"date": "Date",
			"isRefunded": "Is refunded",
			"refundedBy": "Refunded by",
			"refundedAt": "Refunded at",
			"value": "Value",
			"method": "Method",
			"filename": "{{employeeName}}-single-sales",
			"filenameEvent": "-at-event-{{eventName}}",
			"filenamePeriod": "-from-{{since}}-to-{{until}}",
			"title": "Single sales from {{employeeName}} ",
			"titleEvent": "at event {{eventName}} ",
			"titlePeriod": "from {{since}} to {{until}}"
		}
	},
	"parseOpenSaleMethod": {
		"credit": "Credit",
		"debit": "Debit",
		"pix": "Pix",
		"creditInInstallments": "Installment",
		"integratedFoodVoucher": "Food Voucher"
	}
}
